export default function CheckMarkIcon({ small = false }: { small?: boolean }) {
  const size = small ? '20' : '24'
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M21.531 7.28055L9.53104 19.2806C9.46139 19.3503 9.37867 19.4056 9.28762 19.4433C9.19657 19.4811 9.09898 19.5005 9.00042 19.5005C8.90186 19.5005 8.80426 19.4811 8.71321 19.4433C8.62216 19.4056 8.53945 19.3503 8.46979 19.2806L3.21979 14.0306C3.07906 13.8898 3 13.699 3 13.4999C3 13.3009 3.07906 13.11 3.21979 12.9693C3.36052 12.8286 3.55139 12.7495 3.75042 12.7495C3.94944 12.7495 4.14031 12.8286 4.28104 12.9693L9.00042 17.6896L20.4698 6.2193C20.6105 6.07857 20.8014 5.99951 21.0004 5.99951C21.1994 5.99951 21.3903 6.07857 21.531 6.2193C21.6718 6.36003 21.7508 6.55091 21.7508 6.74993C21.7508 6.94895 21.6718 7.13982 21.531 7.28055Z'
        fill='currentColor'
      />
    </svg>
  )
}
